<template>
  <div>
    <main class="main-content">
      <div class="page-content">
        <div class="container-xl">
          <div class="lds-ring" v-if="isLoadingGetClients">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <section
              class="story-templates story-templates_clients story-templates_all-clients"
              v-if="!isLoadingGetClients">
            <div class="page-title page-title_clients">
              <h2 class="copylink-btn" :data-clipboard-text="linkClient">
                All Clients
              </h2>
              <div class="story-templates__table__top story-templates__table__top-my-clients all-clients__filters">
                <a
                    class="story-templates__table__top-clear"
                    :style="{cursor: 'pointer'}"
                    @click="clearSearch"
                >Clear</a
                >
                <div
                    class="form-control-wrap form-control-wrap__search form-control-wrap_1">
                  <input
                      type="text"
                      placeholder="Search"
                      v-model="templateFindClients.params.group"
                      v-on:keyup.enter="searchClients"
                      class="form-control-search" />
                </div>
                <div
                    :class="[
                    'form-control-wrap form-control-wrap__date form-control-wrap_2 datepicker-select select-wrapper',
                    {'is-active': selects.date},
                  ]"
                    @click="openSelect('date')">
                  <div class="select-trigger">
                    <input
                        type="text"
                        placeholder="Date"
                        v-model="templateFindClients.params.travelTime"
                        class="form-control" />
                    <div class="form-control-icon">
                      <svg width="1em" height="1em" class="icon icon-calendar">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar"></use>
                      </svg>
                    </div>
                  </div>
                  <div class="select-body">
                    <div class="datepicker-select-inner">
                      <div class="year-wrap" @click.prevent.stop>
                        <a
                            href="javascript:void(0)"
                            class="year-arr year-arr--prev"
                            @click="searchYear--">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </a>
                        <span class="year-wrap__value"> {{ searchYear }} </span>
                        <a
                            href="javascript:void(0)"
                            class="year-arr year-arr--next"
                            @click="searchYear++">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-chevron">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                          </svg>
                        </a>
                      </div>
                      <div class="month-list">
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Jan ' + searchYear">
                          January
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Feb ' + searchYear">
                          February
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Mar ' + searchYear">
                          March
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Apr ' + searchYear">
                          April
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'May ' + searchYear">
                          May
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Jun ' + searchYear">
                          June
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Jul ' + searchYear">
                          July
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Aug ' + searchYear">
                          August
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Sep ' + searchYear">
                          September
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Oct ' + searchYear">
                          October
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Nov ' + searchYear">
                          November
                        </div>
                        <div
                            class="month-list__item"
                            @click="templateFindClients.params.travelTime = 'Dec ' + searchYear">
                          December
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    class="form-control-wrap form-control-wrap__select form-control-wrap_3">
                  <div
                      :class="[
                      'select-wrapper select-wrapper',
                      {'is-active': selects.status},
                    ]"
                      @click="openSelect('status')">
                    <div class="select-trigger select-trigger-md">
                      <span class="select-trigger__name">{{
                          templateFindClients.params.statuses === 'PROFORMA' ? 'Pro-forma' :
                              templateFindClients.params.statuses === 'DEPOSIT_PAID' ? 'Deposit Paid' :
                                  templateFindClients.params.statuses === 'FULL_PAID' ? 'Full Paid' :
                                      templateFindClients.params.statuses === 'COMPLETED' ? 'Completed' :
                                          templateFindClients.params.statuses === 'NO_RESPONSE_1' ? 'NR 1' :
                                              templateFindClients.params.statuses === 'NO_RESPONSE_2' ? 'NR 2' :
                                                  templateFindClients.params.statuses === 'LEAD' ? 'Lead' :
                                                      templateFindClients.params.statuses === 'NEGOTIATION' ? 'Negotiation' :
                              templateFindClients.params.statuses === 'POSTPONE' ? 'Postponed' :
                                  templateFindClients.params.statuses === 'CANCELLED' ? 'Cancelled' :
                                  templateFindClients.params.statuses === 'DELETED' ? 'Deleted' : 'Status'
                        }}</span
                      ><span class="select-trigger__icon">
                        <svg width="1em" height="1em" class="icon icon-chevron">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                        ></span>
                    </div>
                    <div class="select-body">
                      <div class="select-inner custom-scroll js-scrollbar">
<!--                        <div-->
<!--                            :class="[-->
<!--                            'select-option',-->
<!--                            {'is-selected': search.status === 'All Statuses'},-->
<!--                          ]"-->
<!--                            @click="search.status = 'All Statuses'">-->
<!--                          <span class="select-option__name">All Statuses</span>-->
<!--                        </div>-->
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'PROFORMA'},
                          ]"
                            @click="templateFindClients.params.statuses = 'PROFORMA'">
                          <span class="select-option__name">Pro-forma</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'DEPOSIT_PAID'},
                          ]"
                            @click="templateFindClients.params.statuses = 'DEPOSIT_PAID'">
                          <span class="select-option__name">Deposit Paid</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'FULL_PAID'},
                          ]"
                            @click="templateFindClients.params.statuses = 'FULL_PAID'">
                          <span class="select-option__name">Full Paid</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'COMPLETED'},
                          ]"
                            @click="templateFindClients.params.statuses = 'COMPLETED'">
                          <span class="select-option__name">Completed</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'NO_RESPONSE_1'},
                          ]"
                            @click="templateFindClients.params.statuses = 'NO_RESPONSE_1'">
                          <span class="select-option__name">NR 1</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'NO_RESPONSE_2'},
                          ]"
                            @click="templateFindClients.params.statuses = 'NO_RESPONSE_2'">
                          <span class="select-option__name">NR 2</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'LEAD'},
                          ]"
                            @click="templateFindClients.params.statuses = 'LEAD'">
                          <span class="select-option__name">Lead</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'NEGOTIATION'},
                          ]"
                            @click="templateFindClients.params.statuses = 'NEGOTIATION'">
                          <span class="select-option__name">Negotiation</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'POSTPONE'},
                          ]"
                            @click="templateFindClients.params.statuses = 'POSTPONE'">
                          <span class="select-option__name">Postponed</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'CANCELLED'},
                          ]"
                            @click="templateFindClients.params.statuses = 'CANCELLED'">
                          <span class="select-option__name">Cancelled</span>
                        </div>
                        <div
                            :class="[
                            'select-option',
                            {'is-selected': templateFindClients.params.statuses === 'DELETED'},
                          ]"
                            @click="templateFindClients.params.statuses = 'DELETED'">
                          <span class="select-option__name">Deleted</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                    :class="['select-wrapper', {'is-active': selects.operator}]"
                    style="margin-left: 10px; max-width: 200px"
                    @click="openSelect('operator')">
                  <div class="select-trigger">
                    <span class="select-trigger__name">{{
                        search.operator.length > 0
                            ? search.operator.map((op) => op.companyName).join(', ')
                            : 'Operator'
                      }}</span
                    ><span class="select-trigger__icon">
                      <svg width="1em" height="1em" class="icon icon-chevron">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                      ></span>
                  </div>
                  <div class="select-body">
                    <div class="select-inner js-scrollbar">
                      <div class="select-option">
                        <label
                            class="form-control-checkbox form-control-checkbox-add-flight"
                            @click.prevent.stop="search.operator = []">
                          <input
                              type="checkbox"
                              :checked="search.operator.length < 1" /><span
                            class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                        ><span class="select-option__name">All</span>
                        </label>
                      </div>
                      <div
                          v-for="op in dataOperators"
                          :key="op.id"
                          :class="[
                          'select-option',
                          {
                            'is-selected': search.operator
                              .map((item) => item.id)
                              .includes(op.id),
                          },
                        ]">
                        <label
                            class="form-control-checkbox form-control-checkbox-add-flight"
                            @click.prevent.stop="
                            () => {
                              if (
                                !search.operator
                                  .map((item) => item.id)
                                  .includes(op.id)
                              ) {
                                search.operator.push(op)
                              } else {
                                search.operator = search.operator.filter(
                                  (i) => !(i.id === op.id)
                                )
                              }
                            }
                          ">
                          <input
                              type="checkbox"
                              :checked="
                              search.operator
                                .map((item) => item.id)
                                .includes(op.id)
                            "
                              @click.prevent.stop /><span
                            class="form-control-checkbox__box">
                            <svg
                                width="1em"
                                height="1em"
                                class="icon icon-check">
                              <use
                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                        ><span class="select-option__name">{{
                            op.companyName
                          }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="invoices_filter-managers">
                    <v-select
                        v-model="templateFindClients.params.managers"
                        :options="allClients"
                        :reduce="(item) => item.id"
                        :filterable="false"
                        :clearable="false"
                        :searchable="false"
                        label="firstName"
                        placeholder="Manager"
                        class="new-select"
                    >

                      <template #open-indicator>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="8"
                            height="5"
                            viewBox="0 0 8 5"
                            fill="none">
                          <path
                              d="M7.872.418 7.61.138a.423.423 0 0 0-.619 0l-2.99 3.164L1.01.135a.422.422 0 0 0-.619 0L.128.413a.483.483 0 0 0 0 .655L3.691 4.85a.437.437 0 0 0 .31.149h.002a.437.437 0 0 0 .31-.149l3.56-3.773A.482.482 0 0 0 8 .747a.477.477 0 0 0-.128-.33Z"
                              fill="#606060" />
                        </svg>
                      </template>
                      <template #option="option" >
                        <div class="select__item d-center">
                          <div class="managers-list__item__image h-object-fit">
                            <img v-if="allClients.find((u) => u.id === option.id).photo"
                                :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                                alt="image" />
                            <span v-else></span>
                          </div>
                          <span>{{ option.firstName }}</span>
                        </div>
                      </template>
                      <template #selected-option="option">
                        <div class="selected d-center">
                          <div class="managers-list__item__image h-object-fit">
                            <img v-if="allClients.find((u) => u.id === option.id).photo"
                                :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === option.id)
                                ? allClients.find((u) => u.id === option.id).photo
                                : '797d11d3-ab79-4d9a-b68e-7410b4c1dd3c'
                            }?size=SMALL`"
                                alt="image" />
                            <span v-else></span>
                          </div>
                          <span>{{ option.firstName }}</span>
                        </div>
                      </template>

                    </v-select>
                  </div>
                <a
                    id="searchClient"
                    href="javascript:void(0)"
                    class="btn btn--green btn_search-vs"
                    @click="searchClients"
                >
                  <svg width="1em" height="1em" class="icon icon-search">
                    <use
                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-search"></use>
                  </svg>
                </a>
              </div>
            </div>
            <simplebar class="section-table-wrap clients-wrapper">
              <div class="table-wrapper js-table-wrap">
                <div class="tabs-nav-wrap">
                  <div class="tabs-nav tabs-nav_light">
                    <a
                        :class="['tabs-nav__item', {active: tab === 0}]"
                        @click="
                        tab = 0
                        page = 1
                        templateFindClients.params.page = 1
                        findTabType()
                      ">
                      <svg width="1em" height="1em" class="icon icon-leads">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-leads"></use>
                      </svg>
                      <span class="tabs-nav__text">Leads</span>
                      <span class="badges">{{ sizeStatusClients.LEAD}}</span>
                    </a>
                    <a
                        :class="['tabs-nav__item', {active: tab === 1}]"
                        @click="
                        tab = 1
                        page = 1
                        templateFindClients.params.page = 1
                        findTabType()
                      ">
                      <svg width="1em" height="1em" class="icon icon-clients">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-clients"></use>
                      </svg>
                      <span class="tabs-nav__text">Clients Onboard</span>
                      <span class="badges">{{sizeStatusClients.ONBOARD}}</span>
                    </a>
                    <a
                        :class="['tabs-nav__item', {active: tab === 2}]"
                        @click="
                        tab = 2
                        page = 1
                        templateFindClients.params.page = 1
                        findTabType()
                      ">
                      <svg width="1em" height="1em" class="icon icon-follow-up">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-follow-up"></use>
                      </svg>
                      <span class="tabs-nav__text">Need Follow Up </span>
                      <span class="badges">{{sizeStatusClients.NEED_FOLLOW_UP}}</span>
                    </a>
                    <a
                        :class="['tabs-nav__item', {active: tab === 3}]"
                        @click="
                        tab = 3
                        page = 1
                        templateFindClients.params.page = 1
                        findTabType()
                      ">
                      <svg width="1em" height="1em" class="icon icon-proposal">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-proposal"></use>
                      </svg>
                      <span class="tabs-nav__text">Proposal</span>
                      <span class="badges">{{sizeStatusClients.PROPOSAL}}</span>
                    </a>
                    <a
                        :class="['tabs-nav__item', {active: tab === 4}]"
                        @click="
                        tab = 4
                        page = 1
                        templateFindClients.params.page = 1
                        findTabType()
                      ">
                      <svg width="1em" height="1em" class="icon icon-arhive">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-arhive"></use>
                      </svg>
                      <span class="tabs-nav__text">Archive</span>
                    </a>
                  </div>
                  <label
                      for="chk_140__free"
                      class="form-control-checkbox form-control-checkbox-pickup_2">
                    <input
                        id="chk_140__free"
                        type="checkbox"
                        v-model="showNotes"
                        class="js-check-notes" /><span
                      class="form-control-checkbox__box">
                      <svg width="1em" height="1em" class="icon icon-check">
                        <use
                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                  ><span class="form-control-checkbox__name">Show notes</span>
                  </label>
                </div>

                <div class="story-templates__table-wrap all-clients__table">
                  <div class="story-templates__table clients-templates__table">
                    <div class="story-templates__table__head">
                      <div class="col col-status"><span>Status</span></div>
                      <div class="col col-group-name">
                        <span>Group Name</span>
                        <svg
                            @click="sortClients('group-name')"
                            width="1em"
                            height="1em"
                            class="icon icon-double-arrows">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-double-arrows"></use>
                        </svg>
                      </div>
                      <div class="col col-pax"><span>Pax</span></div>
                      <div class="col col-travel-time">
                        <span>Travel Time</span>
                        <svg
                            @click="sortClients('travel-time')"
                            width="1em"
                            height="1em"
                            class="icon icon-double-arrows">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-double-arrows"></use>
                        </svg>
                      </div>
                      <div class="col col-amount"><span>Amount</span></div>
                      <div class="col col-last-contact">
                        <span>Last Contact</span>
                        <svg
                            @click="sortClients('last-contact')"
                            width="1em"
                            height="1em"
                            class="icon icon-double-arrows">
                          <use
                              xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-double-arrows"></use>
                        </svg>
                      </div>
                      <div class="col col-email">
                        <span>Email / Cell phone</span>
                      </div>
                      <div class="col col-icons"></div>
                      <div class="col col-fl"></div>
                      <div class="col col-shared"><span>Manager</span></div>
                      <div class="col col-action"></div>
                    </div>
                    <div
                        class="story-templates__table__row"
                        v-for="(item, index) in clients"
                        :key="item.id">
                      <div class="col col-status">

                        <div
                            :class="[
                            'select-wrapper',
                            {'is-active': item.isStatusSelect},
                          ]"
                            @click="isStatusOpenMenu(item.id)">
                          <div class="select-trigger select-trigger-md">
                            <span
                                :class="
                                'status-item status-' +
                                (item.status === 'PROFORMA'
                                  ? 'pro'
                                  : item.status === 'DEPOSIT_PAID'
                                  ? 'deposit'
                                  : item.status === 'FULL_PAID'
                                  ? 'full'
                                  : item.status === 'COMPLETED'
                                  ? 'completed'
                                  : item.status === 'NO_RESPONSE_1'
                                  ? 'respose'
                                  : item.status === 'NO_RESPONSE_2'
                                  ? 'respose'
                                  : item.status === 'DELETED'
                                  ? 'deleted'
                                  : item.status.toLowerCase())
                              ">
                              {{
                                item.status === 'PROFORMA'
                                    ? 'Pro-forma'
                                    : item.status === 'DEPOSIT_PAID'
                                        ? 'Deposit paid'
                                        : item.status === 'FULL_PAID'
                                            ? 'Full Paid'
                                            : item.status === 'COMPLETED'
                                                ? 'Completed'
                                                : item.status === 'NO_RESPONSE_1'
                                                    ? 'NR 1'
                                                    : item.status === 'NO_RESPONSE_2'
                                                        ? 'NR 2'
                                                        : item.status === 'POSTPONE'
                                                            ? 'Postponed'
                                                            : item.status === 'DELETED'
                                                                ? 'Deleted'
                                                                : item.status.toLowerCase()
                              }}</span
                            >
                            <span class="select-trigger__icon">
                              <svg
                                  width="1em"
                                  height="1em"
                                  class="icon icon-chevron">
                                <use
                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use>
                              </svg>
                            </span>
                          </div>
                          <div class="select-body">
                            <div
                                class="select-inner custom-scroll js-scrollbar">
                              <!-- <simplebar > -->
                              <div class="select-option">
                                <span
                                    class="status-item status-pro"
                                    @click="
                                    item.status = 'PROFORMA'
                                    updateStatusClientHandler(
                                      item.id,
                                      'PROFORMA'
                                    )
                                  "
                                >Pro-forma</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-deposit"
                                    @click="
                                    item.status = 'DEPOSIT_PAID'
                                    updateStatusClientHandler(
                                      item.id,
                                      'DEPOSIT_PAID'
                                    )
                                  "
                                >Deposit Paid</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-full"
                                    @click="
                                    item.status = 'FULL_PAID'
                                    updateStatusClientHandler(
                                      item.id,
                                      'FULL_PAID'
                                    )
                                  "
                                >Full Paid</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-completed"
                                    @click="
                                    item.status = 'COMPLETED'
                                    updateStatusClientHandler(
                                      item.id,
                                      'COMPLETED'
                                    )
                                  "
                                >Completed</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-respose"
                                    @click="
                                    item.status = 'NO_RESPONSE_1'
                                    updateStatusClientHandler(
                                      item.id,
                                      'NO_RESPONSE_1'
                                    )
                                  "
                                >NR 1</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-respose"
                                    @click="
                                    item.status = 'NO_RESPONSE_2'
                                    updateStatusClientHandler(
                                      item.id,
                                      'NO_RESPONSE_2'
                                    )
                                  "
                                >NR 2</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-lead"
                                    @click="
                                    item.status = 'LEAD'
                                    updateStatusClientHandler(item.id, 'LEAD')
                                  "
                                >Lead</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-negotiation"
                                    @click="
                                    item.status = 'NEGOTIATION'
                                    updateStatusClientHandler(
                                      item.id,
                                      'NEGOTIATION'
                                    )
                                  "
                                >Negotiation</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-postpone"
                                    @click="
                                    item.status = 'POSTPONE'
                                    updateStatusClientHandler(
                                      item.id,
                                      'POSTPONE'
                                    )
                                  "
                                >Postponed</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-cancelled"
                                    @click="
                                    item.status = 'CANCELLED'
                                    updateStatusClientHandler(
                                      item.id,
                                      'CANCELLED'
                                    )
                                  "
                                >Cancelled</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-proposal"
                                    @click="
                                    item.status = 'PROPOSAL'
                                    updateStatusClientHandler(
                                      item.id,
                                      'PROPOSAL'
                                    )
                                  "
                                >Proposal</span
                                >
                              </div>
                              <div class="select-option">
                                <span
                                    class="status-item status-deleted"
                                    @click="
                                    item.status = 'DELETED'
                                    updateStatusClientHandler(
                                      item.id,
                                      'DELETED'
                                    )
                                  "
                                >Deleted</span
                                >
                              </div>
                              <!-- </simplebar> -->
                            </div>
                          </div>
                        </div>
                        <div
                            class="important-client-ic"
                            v-if="item.priorityClient">
                          <svg width="1em" height="1em" class="icon icon-fire">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-fire"></use>
                          </svg>
                        </div>
                      </div>
                      <div class="col col-group-name">
                        <a :href="`/clients/${item.id}`"
                           target="_blank">{{ item.groupName }}</a>
                      </div>
                      <div class="col col-pax">
                        <span>{{ item.pax }}</span>
                      </div>
                      <div class="col col-travel-time">
                        <span>{{ item.travelTime }}</span>
                      </div>
                      <div class="col col-amount">
                        <span>{{ numberWithCommas(item.amount) }}{{getCurrencySign(item.currency)}} </span>
                        <span
                            :style="{opacity: 0}"
                            class="btn--popover popover-invoice"
                            data-popover="Invoice Deadline 15 June 2021, exceeded by 3 days">
                          <svg
                              width="1em"
                              height="1em"
                              class="icon icon-invoice invoice--ic">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-invoice"></use>
                          </svg>
                        </span>
                      </div>
                      <div class="col col-last-contact">
                        <div
                            class="form-control-wrap form-control-wrap__contact">
                          <input
                              readonly
                              type="text"
                              ref="lastContactRef"
                              :value="item.lastContact"
                              :class="[
                              'form-control act',
                              {'js-datepicker-single': true},
                            ]"
                              @blur="
                              if ($event.target.updated) {
                                $event.target.updated = false
                                item.lastContact = $event.target.value
                                updateLastContactClientHandler(
                                  item.id,
                                  $event.target.value
                                )
                                item.lastContactEdit = false
                              }
                            " />
                          <!--                          <div class="form-control-icon" @click="item.lastContactEdit = !item.lastContactEdit;">-->
                          <!--                            <svg width="1em" height="1em" class="icon icon-edit">-->
                          <!--                              <use-->
                          <!--                                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit">-->
                          <!--                              </use>-->
                          <!--                            </svg>-->
                          <!--                          </div>-->
                        </div>
                      </div>
                      <div class="col col-email">
                        <span
                            @click="copyEmail = true"
                            :data-clipboard-text="
                            item.email ||
                            (item.phone
                              ? item.phone.replace('(', '').replace(')', '')
                              : '')
                          "
                            class="copylink-btn">
                          {{
                            item.email ||
                            (item.phone
                                ? item.phone.replace('(', '').replace(')', '')
                                : '')
                          }}
                        </span>
                        <a
                            v-if="item.whatsApp && item.phone"
                            :href="
                            'https://wa.me/' +
                            item.phone.replace('(', '').replace(')', '')
                          "
                            target="_blank">
                          <svg
                              :style="{minWidth: '16px'}"
                              width="1em"
                              height="1em"
                              class="icon icon-whatsapp mess-ic">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-whatsapp"></use>
                          </svg>
                        </a>
                        <a
                            v-if="item.telegram && item.phone"
                            :href="
                            'tg://resolve?domain=' +
                            item.phone.replace('(', '').replace(')', '')
                          ">
                          <svg
                              :style="{minWidth: '14px', width: '14px'}"
                              width="1em"
                              height="1em"
                              class="icon icon-telegram mess-ic">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-telegram"></use>
                          </svg>
                        </a>
                      </div>
                      <div class="col col-icons">
                        <img
                            v-if="item.programTypes.includes('CLIMBING')"
                            src="/images/useful/svg/clients-icon1.svg"
                            alt="" />
                        <img
                            v-if="item.programTypes.includes('SAFARI')"
                            src="/images/useful/svg/clients-icon2.svg"
                            alt="" />
                        <img
                            v-if="item.programTypes.includes('ISLAND')"
                            src="/images/useful/svg/clients-icon3.svg"
                            alt="" />
                        <img
                            v-if="item.programTypes.includes('ISLAND_COMPACTED')"
                            src="/images/useful/svg/clients-icon3.svg"
                            alt="" />
                      </div>
                      <div class="col col-fl">
                        <span class="fl-el">FL1</span>
                        <span class="fl-el disabled">FL2</span>
                      </div>
                      <div
                          class="col col-shared"
                          :class="{
                          'col-shared--scroll': item.sharedUserIds.length > 4,
                        }">
                        <div
                            class="managers-list__item__image h-object-fit"
                            v-for="user in item.sharedUserIds"
                            :key="user">
                          <img v-if="allClients.find((u) => u.id === user)
                                ? allClients.find((u) => u.id === user).photo
                                : null"
                              :src="`${API}/documents/share/images/${
                              allClients.find((u) => u.id === user)
                                ? allClients.find((u) => u.id === user).photo
                                : ''
                            }?size=SMALL`"
                              alt="image" />
                          <span v-else></span>
                        </div>
                      </div>
                      <div class="col col-action">
                        <button
                            type="button"
                            class="story-templates__table__dropdown-trigger"
                            :style="{position: 'relative'}"
                            @click="openMenu(item.id, 'clients')">
                          <svg width="1em" height="1em" class="icon icon-more">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-more"></use>
                          </svg>
<!--                          {{item.menu}}-->
                          <div
                              :class="['edit-popup edit-popup--short']"
                              :style="{zIndex: 100, right: '-18px'}"
                              v-if="item.menu">
                            <div class="form-control-group">
                              <a
                                  :href="`/clients/${item.id}`"
                                  target="_blank"
                                  class="btn form-control-action"
                              ><span
                                  class="form-control-action__icon icon--green">
                                  <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-edit">
                                    <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-edit"></use></svg></span
                              ><span class="form-control-action__text"
                              >Edit</span
                              >
                              </a>
                            </div>
                            <div class="form-control-group">
                              <button
                                  type="button"
                                  class="btn form-control-action"
                                  @click.stop="
                                  link = true
                                  edit = item
                                ">
                                <span
                                    class="form-control-action__icon icon--blue">
                                  <svg
                                      width="1em"
                                      height="1em"
                                      class="icon icon-link">
                                    <use
                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link"></use></svg></span
                                ><span class="form-control-action__text"
                              >Get a link</span
                              >
                              </button>
                            </div>
<!--                            <div class="form-control-group">-->
<!--                              <button-->
<!--                                  type="button"-->
<!--                                  class="btn form-control-action"-->
<!--                                  @click.stop="copyClient(item)">-->
<!--                                <span-->
<!--                                    class="form-control-action__icon icon&#45;&#45;orange">-->
<!--                                  <svg-->
<!--                                      width="1em"-->
<!--                                      height="1em"-->
<!--                                      class="icon icon-copy">-->
<!--                                    <use-->
<!--                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-copy"></use></svg></span-->
<!--                                ><span class="form-control-action__text"-->
<!--                              >Copy</span-->
<!--                              >-->
<!--                              </button>-->
<!--                            </div>-->
<!--                            <div class="form-control-group">-->
<!--                              <button-->
<!--                                  type="button"-->
<!--                                  class="btn form-control-action"-->
<!--                                  @click.stop="-->
<!--                                  share = true-->
<!--                                  edit = item-->
<!--                                ">-->
<!--                                <span-->
<!--                                    class="form-control-action__icon icon&#45;&#45;light-green">-->
<!--                                  <svg-->
<!--                                      width="1em"-->
<!--                                      height="1em"-->
<!--                                      class="icon icon-letter">-->
<!--                                    <use-->
<!--                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-letter"></use></svg></span-->
<!--                                ><span class="form-control-action__text"-->
<!--                              >Share</span-->
<!--                              >-->
<!--                              </button>-->
<!--                            </div>-->
<!--                            <div class="form-control-group">-->
<!--                              <button-->
<!--                                  type="button"-->
<!--                                  class="btn form-control-action"-->
<!--                                  @click.stop="-->
<!--                                  transfer = true-->
<!--                                  edit = item-->
<!--                                ">-->
<!--                                <span-->
<!--                                    class="form-control-action__icon icon&#45;&#45;dark-grey">-->
<!--                                  <svg-->
<!--                                      width="1em"-->
<!--                                      height="1em"-->
<!--                                      class="icon icon-transfer">-->
<!--                                    <use-->
<!--                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-transfer"></use></svg></span-->
<!--                                ><span class="form-control-action__text"-->
<!--                              >Transfer to</span-->
<!--                              >-->
<!--                              </button>-->
<!--                            </div>-->
<!--                            <div class="form-control-group">-->
<!--                              <button-->
<!--                                  type="button"-->
<!--                                  class="btn form-control-action"-->
<!--                                  @click.stop="deleteClientHandler(item)">-->
<!--                                <span-->
<!--                                    class="form-control-action__icon icon&#45;&#45;red">-->
<!--                                  <svg-->
<!--                                      width="1em"-->
<!--                                      height="1em"-->
<!--                                      class="icon icon-close">-->
<!--                                    <use-->
<!--                                        xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use></svg></span-->
<!--                                ><span class="form-control-action__text"-->
<!--                              >Delete</span-->
<!--                              >-->
<!--                              </button>-->
<!--                            </div>-->
                          </div>
                        </button>
                      </div>
                      <div
                          :class="[
                          'story-templates__table__reason js-notes-item',
                          {active: showNotes && item.notesForManager},
                        ]">
                        <span>Note:</span>
                        <span v-html="item.notesForManager"></span>
                      </div>
                    </div>

                  </div>
                </div>

              </div>
            </simplebar>
          </section>
          <pagination
              :page="page"
              :pageCount="pageCount"
              @pageController="pageController"
          />
        </div>
      </div>
    </main>
    <div class="modal-wrapper" v-if="showCopyLinkModal || copyEmail">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--copy-link">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-link">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-link"></use>
                </svg>
              </div>
              <span v-if="showCopyLinkModal">The program link</span
              ><span v-if="copyEmail">Client email</span>
            </div>
          </div>
          <div class="edit-popup__text">
            <p v-if="showCopyLinkModal">
              The link was successfully copied. Click Ctrl+V to insert it into
              your email or messenger
            </p>
            <p v-if="copyEmail">Email copied!</p>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="share">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--share">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-letter">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-letter"></use>
                </svg>
              </div>
              <span>Share the client</span>
            </div>
            <div class="edit-popup__close" @click="share = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup--share__form">
            <div class="form-control-group">
              <span class="form-control-label">Select Managers</span>
              <div
                  :class="[
                  'select-wrapper select-wrapper--managers',
                  {'is-active': usersSelect},
                ]"
                  @click="usersSelect = !usersSelect">
                <div class="select-trigger">
                  <div class="select-trigger__name">
                    <div
                        class="select-trigger__manager"
                        v-for="user in selectShareClients.filter((item) => item.active)"
                        :key="user.id">
                      <div class="select-option__image h-object-fit">
                        <img
                            :src="`${API}/documents/share/images/${user.photo}?size=SMALL`"
                            alt="kiril" />
                      </div>
                      <span>{{ user.firstName }},</span>
                    </div>
                  </div>
                  <span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                    ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                        class="select-option"
                        v-for="user in selectShareClients"
                        :key="user.id">
                      <label
                          class="form-control-checkbox"
                          @click.stop="user.active = !user.active">
                        <input
                            type="checkbox"
                            :checked="user.active"
                            @click.prevent.stop /><span
                          class="form-control-checkbox__box">
                          <svg width="1em" height="1em" class="icon icon-check">
                            <use
                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check"></use></svg></span
                      ><span class="select-option__image h-object-fit"
                      ><img
                          :src="`${API}/documents/share/images/${user.photo}?size=SMALL`"
                          alt="kiril" /></span
                      ><span class="select-option__name">{{
                          user.firstName
                        }}</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
                type="submit"
                class="btn btn--green"
                @click="shareClientHandler">
              <span>Share client</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="transfer">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup edit-popup--share">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <div class="edit-popup__title__icon">
                <svg width="1em" height="1em" class="icon icon-letter">
                  <use
                      xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-letter"></use>
                </svg>
              </div>
              <span>Transfer To</span>
            </div>
            <div class="edit-popup__close" @click="transfer = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup--share__form">
            <div class="form-control-group">
              <span class="form-control-label">Select Manager</span>
              <div
                  :class="[
                  'select-wrapper select-wrapper--managers',
                  {'is-active': usersSelect},
                ]"
                  @click="usersSelect = !usersSelect">
                <div class="select-trigger">
                  <div class="select-trigger__name">
                    <div
                        class="select-option__image h-object-fit"
                        v-if="transferManager">
                      <img
                          :src="`${API}/documents/share/images/${transferManager.photo}?size=SMALL`"
                          alt="kiril" />
                    </div>
                    <span v-if="transferManager">{{
                        transferManager.firstName
                      }}</span>
                  </div>
                  <span class="select-trigger__icon">
                    <svg width="1em" height="1em" class="icon icon-chevron">
                      <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron"></use></svg
                    ></span>
                </div>
                <div class="select-body">
                  <div class="select-inner js-scrollbar">
                    <div
                        class="select-option"
                        v-for="user in selectTransferClients"
                        :key="user.id"
                        @click="transferManager = user">
                      <span class="select-option__image h-object-fit"
                      ><img
                          :src="`${API}/documents/share/images/${user.photo}?size=SMALL`"
                          alt="kiril" /></span
                      ><span class="select-option__name">{{
                        user.firstName
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button
                type="submit"
                class="btn btn--green"
                :disabled="!transferManager"
                @click="onTransferClient">
              <span>Transfer client</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isModalChangeSaving" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="modal-body">
          <div class="modal-body__icon">
            <svg width="1em" height="1em" class="icon icon-check-rounded">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-check-rounded"></use>
            </svg>
          </div>
          <span class="modal-body__title">Changes Saved!</span>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="isModalError" :style="{zIndex: 200}">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="modal-body">
          <div class="modal-body__icon">
            <svg width="1em" height="1em" class="icon icon-error">
              <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-error"></use>
            </svg>
          </div>
          <span class="modal-body__title">Something went wrong</span>
          <span class="modal-body__subtitle">{{ errorText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
import simplebar from 'simplebar-vue'
import ClipboardJS from 'clipboard'
import {API, getClientLink, getPartners, updateStatusClient} from "@/utilites/api";
import {actionTypes as actionTypesClients, getterTypes as getterTypesClients} from "@/store/modules/clients";
import {actionTypes as actionTypesAuth, getterTypes as getterTypesAuth} from "@/store/modules/auth";
import Pagination from "@/components/Pagination";
import Lightpick from "lightpick";
import {date} from '@/utilites/functions'
import {getCurrencySign} from '../../common/helpers/currency'

export default {
  name: "AtAllClients",
  props: ['user'],
  components: {Lightpick, simplebar, ClipboardJS, Pagination},
  data() {
    return {
      API: API,
      copyEmail: false,
      showCopyLinkModal: false,
      isStatusSelect: false,
      isModalChangeSaving: false,
      isModalError: false,
      page: 1,
      pageCount: 0,
      showNotes: false,
      link: false,
      edit: false,
      share: false,
      transfer: false,
      linkClient: '',
      dataOperators: [],
      users: [],
      selectShareClients: [],
      selectTransferClients: [],
      transferManager: null,
      usersSelect: false,
      selects: {
        status: false,
        operator: false,
        date: false,
      },
      search: {
        string: '',
        status: '',
        operator: [],
        date: '',
      },
      tab: 0,
      tabType: [
        {name: 'Lead', type: 'LEAD'},
        {name: 'Onboard', type: 'ONBOARD'},
        {name: 'Need follow up', type: 'NEED_FOLLOW_UP'},
        {name: 'Proposal', type: 'PROPOSAL'},
        {name: 'Archive', type: 'ARCHIVE'},
        {name: 'Deleted', type: 'DELETED'}
      ],
      searchYear: new Date().getFullYear(),
      templateFindClients: {
        all: true,
        id: this.user.id,
        type: 'LEAD',
        params: {
          group: null,
          travelTime: null,
          statuses: null,
          operators: null,
          managers: null,
          groupSort: null,
          travelTimeSort: null,
          lastContactSort: null,
          limit: 30,
          page: 1
        }
      }
    }
  },
  beforeCreate() {
    document.title = 'All Clients'
  },
  mounted() {
    this.findClients()
    let clip = new ClipboardJS('.copylink-btn')
    window.addEventListener('click', (event) => {
      event.stopPropagation()
      if (!event.target.closest('.select-wrapper')) {
        this.selects = {
              status: false,
              operator: false,
              date: false
        }
      }
      if (!event.target.closest('.story-templates__table__dropdown-trigger')) {
        this.clients.map((item) =>
            item.menu ? item.menu = !item.menu : item.menu = false)
      }
    })
    // const a = document.getElementById("searchClient");
    // window.addEventListener("keydown", function(e) {
    //   if (e.keyCode === 13) a.click()
    // });
  },
  methods: {
    getCurrencySign,
    ...Vuex.mapActions({
      getClients: actionTypesClients.getClients,
      getAllClients: actionTypesAuth.getAllClients,
      clientCopy: actionTypesClients.clientCopy,
      shareClient: actionTypesClients.shareClient,
      transferToClient: actionTypesClients.transferToClient,
      deleteClient: actionTypesClients.deleteClient,
      lastContactClient: actionTypesClients.lastContactClient
    }),
    sortClients(name){
      if (name === 'group-name') {
        this.templateFindClients.params.lastContactSort = null
        this.templateFindClients.params.travelTimeSort = null

        if (this.templateFindClients.params.groupSort) {
          if (this.templateFindClients.params.groupSort === 'DESC') {
            this.templateFindClients.params.groupSort = 'ASC'
          } else {
            this.templateFindClients.params.groupSort = 'DESC'
          }
        } else {
          this.templateFindClients.params.groupSort = 'DESC'
        }
        this.searchClients()
      }
      if (name === 'travel-time') {
        this.templateFindClients.params.lastContactSort = null
        this.templateFindClients.params.groupSort = null

        if (this.templateFindClients.params.travelTimeSort) {
          if (this.templateFindClients.params.travelTimeSort === 'DESC') {
            this.templateFindClients.params.travelTimeSort = 'ASC'
          } else {
            this.templateFindClients.params.travelTimeSort = 'DESC'
          }
        } else {
          this.templateFindClients.params.travelTimeSort = 'DESC'
        }
        this.searchClients()
      }
      if (name === 'last-contact') {
        this.templateFindClients.params.travelTimeSort = null
        this.templateFindClients.params.groupSort = null

        if (this.templateFindClients.params.lastContactSort) {
          if (this.templateFindClients.params.lastContactSort === 'DESC') {
            this.templateFindClients.params.lastContactSort = 'ASC'
          } else {
            this.templateFindClients.params.lastContactSort = 'DESC'
          }
        } else {
          this.templateFindClients.params.lastContactSort = 'DESC'
        }
        this.searchClients()
      }
    },
    updateDatePickers() {
      document.querySelectorAll('.lightpick').forEach((elem) => {
        elem.remove()
      })
      setTimeout(() => {
        document.querySelectorAll('.js-datepicker-single').forEach((item) => {
          const datePicker = new Lightpick({
            field: item,
            singleDate: true,
            lang: 'en',
            format: 'DD MMM YYYY',
            autoclose: false,
            onClose: function () {
              const buttonElement = document.querySelector('.e-btn')
              const buttonSaveElement = document.querySelector('.e-btn--save')
              if (buttonElement) buttonElement.remove()
              if (buttonSaveElement) buttonSaveElement.remove()
              item.blur()
            },
            // onSelect: function (date) {
            //
            // },
            onOpen() {
              const buttonElement = document.createElement('button')
              const buttonSaveElement = document.createElement('button')
              buttonElement.innerText = 'Today'
              buttonElement.className = 'e-btn'
              buttonSaveElement.innerText = 'Save'
              buttonSaveElement.className = 'e-btn e-btn--save'
              buttonElement.addEventListener('click', () => {
                datePicker.setDate(new Date())
                item.updated = true
                item.focus()
                item.blur()
              })
              buttonSaveElement.addEventListener('click', () => {
                datePicker.setDate(datePicker.getDate())
                item.updated = true
                item.focus()
                item.blur()
              })
              datePicker.el.appendChild(buttonElement)
              datePicker.el.appendChild(buttonSaveElement)
            },
          })
        })
      }, 100)
    },
    updateLastContactClient(target){
      // console.log('>> target', target)
      // if ($event.target.updated) {
      //   $event.target.updated = false
      //   item.lastContact = $event.target.value
      //   updateLastContactClientHandler(
      //       item.id,
      //       $event.target.value
      //   )
      //   item.lastContactEdit = false
      // }
    },
    updateLastContactClientHandler(id, dateVal){
      // console.log('>> id', id)
      // console.log('>> dateVal', dateVal)
      this.lastContactClient({
        id: id,
        date: date(dateVal, 'start')
      }).then(() => this.updateDatePickers())
    },
    pageController(page) {
      this.page = page
      this.templateFindClients.params.page = this.page
      this.searchClients()
    },
    pageCountHandler() {
      let arrayClients
      if (this.tab === 0) arrayClients = this.sizeStatusClients.LEAD
      if (this.tab === 1) arrayClients = this.sizeStatusClients.ONBOARD
      if (this.tab === 2) arrayClients = this.sizeStatusClients.NEED_FOLLOW_UP
      if (this.tab === 3) arrayClients = this.sizeStatusClients.PROPOSAL
      if (this.tab === 4) arrayClients = this.sizeStatusClients.ARCHIVE

      this.pageCount = Math.ceil(arrayClients / this.templateFindClients.params.limit)
    },
    deleteClientHandler(program){
      this.deleteClient({
        id: program.id,
        userId: this.user.id
      }).then(() => {
        this.share = false
        this.findClients()
      })
    },
    shareClientHandler(){
      this.shareClient({
        id: this.edit.id,
        userId: this.user.id,
        shareUserIds: this.selectShareClients.filter((item) => item.active).map((item) => item.id)
      }).then(() => {
        this.share = false
        this.findClients()
      })
    },
    onTransferClient(){
      const payload = {
        id: this.edit.id,
        userId: this.user.id,
        transferUserId: this.transferManager.id,
      }
      this.transferToClient(payload)
          .then(() => this.findClients())
          .finally(() => {
            this.transfer = false
            this.transferManager = null
          })
    },
    copyClient(currentClient) {
      this.clientCopy({
        id: currentClient.id,
        userId: this.user.id
      }).then(() => this.findClients())
    },
    isStatusOpenMenu(id){
      this.clients.map((item) => {
            item.id === id ? item.isStatusSelect = !item.isStatusSelect : item.isStatusSelect = false
          }
      )
    },
    openMenu(id, type) {
      this[type].map((item) =>
          item.id === id ? item.menu = !item.menu : item.menu = false
      )
    },
    updateStatusClientHandler(id, status) {
      updateStatusClient(id, status).then((res) => {
        this.findClients()
      })
    },
    findAllClients() {
      this.getAllClients()
    },
    findClients(){
      this.getClients(this.templateFindClients).then(() => {
        this.findAllClients()
        getPartners().then((res) => {
          this.updateDatePickers()
          this.dataOperators = res
        })
      })
    },
    findTabType(){
      this.templateFindClients.type = this.tabType[this.tab].type
      this.findClients()
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    clearSearch() {
      this.templateFindClients.params.group = null
      this.templateFindClients.params.travelTime = null
      this.templateFindClients.params.managers = null
      this.templateFindClients.params.statuses = null
      this.templateFindClients.params.travelTimeSort = null
      this.templateFindClients.params.groupSort = null
      this.templateFindClients.params.lastContactSort = null
      this.search.operator = []
      this.findClients()
    },
    openSelect(type = false) {
      // console.log(type)
      this.selects = {
        status: false,
        date: false,
        [type]: !this.selects[type],
      }
    },
    searchClients(){
      if (this.search.operator.length > 0) {
        this.templateFindClients.params.operators = this.search.operator.map(o => o.id)
      } else {
        this.templateFindClients.params.operators = null
      }
      this.findClients()
    },
  },
  watch: {
    copyEmail() {
      if (this.copyEmail) {
        setTimeout(() => {
          this.copyEmail = false
        }, 2000)
      }
    },
    link() {
      if (!this.link) {
        this.edit = false
      } else {
        this.clients.map((item) => ({...item, menu: false}))
        getClientLink(this.edit.id).then((res) => {
          this.linkClient = window.location.origin + '/itinerary/' + res
          setTimeout(() => {
            document.querySelector('.copylink-btn').click()
            this.showCopyLinkModal = true
          }, 100)
          setTimeout(() => {
            this.link = false
            this.showCopyLinkModal = false
          }, 2000)
        })
      }
    },
    share() {
      if (!this.share) {
        this.edit = false
        this.allClients.map((item) => ({...item, active: false}))
      } else {
        this.selectShareClients = this.allClients.map((item) => ({
          ...item,
          active: this.edit.sharedUserIds.includes(item.id),
        }))
      }
    },
    transfer() {
      if (!this.transfer) {
        this.edit = false
        this.transferManager = null
      } else {
        this.selectTransferClients = this.allClients.map((item) => ({...item, menu: false}))
      }
    },
    allClients(){
      this.pageCountHandler()
    }
  },
  computed: {
    ...Vuex.mapGetters({
      clients: getterTypesClients.clients,
      sizeStatusClients: getterTypesClients.sizeStatusClients,
      isLoadingGetClients: getterTypesClients.isLoadingGetClients,
      allClients: getterTypesAuth.allClients
    }),
  },
}
</script>
